import { detect } from 'detect-browser';

enum SupportedBrowsers {
  CHROME = 'chrome',
  FIREFOX = 'firefox',
  EDGE = 'edge',
  EDGE_CHROMIUM = 'edge-chromium',
  IE = 'ie',
  SAFARI = 'safari',
}

enum UnsupportedOperatingSystem {
  IOS = 'iOS',
  ANDROID_OS = 'Android OS',
  ANDROID = 'android',
}

// createImageBitmap not supported on old browsers: https://developer.mozilla.org/en-US/docs/Web/API/createImageBitmap#browser_compatibility
export function isCreateImageBitmapSupported(): boolean {
  const browser = detect();

  // disabling on some mobile devices and when OS can not be determined
  if (!browser?.os || browser.os in UnsupportedOperatingSystem) {
    return false;
  }

  let createImageBitmapSupported = false;
  if (browser.name && browser.version) {
    const version = Number(browser.version.split('.')[0]);
    switch (browser.name) {
      case SupportedBrowsers.CHROME:
        if (version >= 50) {
          createImageBitmapSupported = true;
        }
        break;
      case SupportedBrowsers.FIREFOX:
        if (version >= 42) {
          createImageBitmapSupported = true;
        }
        break;
      case SupportedBrowsers.EDGE:
      case SupportedBrowsers.EDGE_CHROMIUM:
      case SupportedBrowsers.IE:
        if (version >= 79) {
          createImageBitmapSupported = true;
        }
        break;
      case SupportedBrowsers.SAFARI:
        if (version >= 15) {
          createImageBitmapSupported = true;
        }
        break;
      default:
        break;
    }
  }
  return createImageBitmapSupported;
}
